var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list-day-event"},_vm._l((_vm.timelineItems),function(item,index){return _c('li',{key:index,staticClass:"list-day-event__item m-b-4"},[_c('div',{staticClass:"list-day-event",class:[
        { info__item__holiday: item.event_type.toLowerCase() == 'holiday' },
        { info__item__event: item.event_type.toLowerCase() == 'event' },
        {
          info__item__exam_schedule:
            item.event_type.toLowerCase() == 'exam schedule'
        }
      ]},[(item.start_date == item.end_date)?_c('span',[_vm._v(_vm._s(_vm.getDay(item.start_date)))]):_c('span',[_vm._v(_vm._s(_vm.getDay(item.start_date))+" - "+_vm._s(_vm.getDay(item.end_date)))])]),_c('span',{staticClass:"list-day-event description"},[_vm._v(_vm._s(item.description))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }